<template>
  <div class="lock-timer">
    <div
      v-if="!locked"
      class="lock-timer-str center-elem"
    >
      {{ waittime }}
    </div>
    <div
      v-else
      class="lock-timer-str center-elem"
    >
      {{ lockwaittime }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TimerView',
    props: {
      waittime: {
        type: String,
        required: true
      },
      lockwaittime: {
        type: String,
        required: true
      },
      locked: {
        type: Boolean,
        required: true
      },
      count: {
        type: Number,
        required: true
    },
    data: {
      type: Object,
      default: () => ({})
    },
    mounted: {
      type: Object,
      default: () => ({})
    },
    beforeUnmount: {
      type: Object,
      default: () => ({})
    },
    methods: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style>
.lock-timer {
  background-color: rgba(255,255,255,0.8);
  height: 180px;
  margin-top: calc((var(--vh, 1vh) * 100 - 66px - 180px) / 2);
  position: relative;
  cursor: default;
  user-select: none;
  z-index: 100;
}

.lock-timer-str {
  font-size: min(30vw, 10em);
}
</style>